import {axios} from "@/plugins/http-axios";
import cons from "@/store/cons";
import {Module} from "vuex";
import {RootState} from "@/store/index";
import {IData} from "@/types/globalTypes";
interface IEnvLkk{
    [key:string]:string|boolean;
}
interface IFlag{
    "code": string;
    "desc": string;
    "value": boolean;
    "affectedSystems": string[];
}
export interface IParameter{
    "code": string;
    "desc": string;
    "value": string;
    "resulttype": string;
}
interface ISystemInfo{
    flags:IFlag[];
    parameters:[];
}

interface IEnvState{
    env:{
        flags:IFlag[];
        parameters:IParameter[];
        lkk:IEnvLkk;
    };
    cons:IData;
}
export default <Module<IEnvState, RootState>>{
    state:{
        env:{
            flags:[],
            parameters:[],
            lkk:{},
        },
        cons: cons,
    },
    mutations:{
        setEnv(state, data:ISystemInfo) {
            state.env.flags = data.flags;
            state.env.parameters = data.parameters;
        },
        setEnvLkk(state, data:IEnvLkk = {}) {
            state.env.lkk = data;
        },
    },
    actions:{
        getEnvLkk({commit, dispatch, rootGetters}):Promise<void> {
            //todo перенести этот зарос в getEnv
            return axios.get<IEnvLkk>(rootGetters.uri.env)
                .then((resp) => {
                    commit('setEnvLkk', resp.data);
                    return Promise.resolve();
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
        async getEnv({commit, dispatch, rootGetters}):Promise<void> {
            //todo выпелить i18n из ответа и перенести в запросы i18n
            return await axios.get(rootGetters.uri.infoSystemInfo)
                .then((resp) => {
                    commit('setI18nBank', resp.data.i18n, {root:true});
                    commit('setEnv', resp.data);
                    return Promise.resolve();
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
    },
    getters: {
        envLkk: (state):IEnvLkk => state.env.lkk,
        cons: (state):IData => state.cons,
        //todo Нужно переделать на объект по ключам code
        flag: state => (code:string):boolean => {
            const flag = state.env.flags.find((flag) => flag.code == code)?.value;
            return flag ?? false;
        },
        //todo Нужно переделать на объект по ключам code
        sysParameter: state => (code:string):IParameter|undefined => state.env.parameters.find(p => p.code === code),
        finalResultContract: (state, getters):boolean|undefined => getters.sysParameter('FINAL_RESULT')?.value == 'contract' || false,
        isHideOffice: (state, getters):boolean => getters.flag('HIDE_OFFICE'),
        ENV_SCAN_DOCUMENT_FM: state => state.env.lkk['SCAN_DOCUMENTS'] || false,
        isComment: (state, getters):boolean => getters.flag('SHOW_COMMENT'),
        ENV_UNEP_ENABLE: (state, getters):boolean => getters.flag('UNEP_ENABLE'),
        ENV_UNEP_ENABLE_FL: (state, getters):boolean => getters.flag('UNEP_ENABLE_FL'),
        INDIVIDUAL_ENABLE: (state, getters):boolean => getters.flag('INDIVIDUAL_ENABLE'),
        LEGAL_ENTITY_ENABLE: (state, getters):boolean => getters.flag('LEGAL_ENTITY_ENABLE'),

        ENV_HIDING_FOLDERS: (state, getters):boolean => getters.flag('HIDING_FOLDERS'),
        GET_UNEP_FIO_SN: (state, getters):boolean => getters.flag('UNEP_FIO_SN'),
        isHideDarkTheme: (state, getters):boolean => getters.flag('DARK_THEME'),
        getBankName: (state, getters): boolean => getters.sysParameter('XP_BANK_NAME')?.value ?? '',
        getBranchName: (state, getters): boolean => getters.sysParameter('BRANCH')?.value ?? '',
        isNewQuestionnaireMode: (state, getters): boolean => getters.flag('IS_NEW_QUESTIONNAIRE_MODE'),
    }

};
